{
  "agreements": {
    "column": {
      "claim-option": "Claimoptie",
      "currency": "Valuta",
      "description": "Omschrijving",
      "more": "meer",
      "number": "Nr.",
      "type": "Type",
      "valid-from": "Geldig vanaf",
      "valid-to": "Geldig tot"
    },
    "header": {
      "intro": "Bekijk uw huidige overeenkomsten. Klik op de knop ‘claim indienen’ om een claim te starten.",
      "title": "Overzicht van overeenkomsten"
    },
    "product": {
      "billback-rate": "Billback-tarief / kg.",
      "code": "LW-code",
      "name": "Producten"
    },
    "table": {
      "detail": {
        "contact": "Contact:",
        "lwm-contact": "LW-contact:",
        "download-pdf": "Overeenkomst als pdf downloaden"
      },
      "empty": "Geen overeenkomsten beschikbaar",
      "submit-claim": "Claim indienen"
    },
    "type": {
      "billback": "Billback-overeenkomst QTE"
    }
  },
  "amplify": {
    "2 validation errors detected: Value at 'password' failed to satisfy constraint: Member must have length greater than or equal to 6; Value at 'password' failed to satisfy constraint: Member must satisfy regular expression pattern: ^[\\S]+.*[\\S]+$": "Het wachtwoord moet aan de volgende vereisten voldoen: Minimale wachtwoordlengte van 6 tekens; hoofdletters (A-Z); kleine letters (a-z); cijfers (0-9)",
    "2 validation errors detected: Value at 'password' failed to satisfy constraint: Member must satisfy regular expression pattern: ^[\\S]+.*[\\S]+$; Value at 'password' failed to satisfy constraint: Member must have length greater than or equal to 6": "Er zijn 2 validatiefouten ontdekt: Waarde bij 'wachtwoord' voldoet niet aan vereiste: Wachtwoord moet aan 'regular expression'-patroon voldoen: ^[\\S]+.*[\\S]+$; Waarde bij 'wachtwoord' voldoet niet aan vereiste: Wachtwoord moet 6 of meer tekens lang zijn",
    "Account recovery requires verified contact information": "Voor het herstellen van je account zijn geverifieerde contactgegevens nodig.",
    "An account with the given email already exists.": "Er bestaat al een account met dit e-mailadres.",
    "Apply code from MFA app": "Voer de code in van je multifactor-authenticatie-service",
    "Apply code from SMS": "Voer de code in die naar je mobiele telefoon is gestuurd.",
    "Back to Sign In": "Terug naar inloggen",
    "Cancel": "Annuleren",
    "Change Password": "Wachtwoord wijzigen",
    "Code": "Code",
    "Confirm": "Bevestigen",
    "Confirm password": "Bevestig wachtwoord",
    "Confirm Sign In": "Inloggen bevestigen",
    "Confirm Sign Up": "We hebben een bevestigingscode naar je e-mailadres gestuurd.",
    "Confirm a Code": "Een code bevestigen",
    "Confirmation Code": "Bevestigingscode",
    "Create Account": "Account aanmaken",
    "Create a new account": "Een nieuw account aanmaken",
    "Create account": "Account aanmaken",
    "Custom auth lambda trigger is not configured for the user pool.": "Wachtwoord moet ingevuld zijn",
    "Email": "E-mail",
    "Email address": "E-mailadres",
    "Enter your Email address": "Voer je e-mailadres in",
    "Enter your password": "Voer je wachtwoord in",
    "Enter your username": "Voer je gebruikersnaam in",
    "Forgot Password": "Wachtwoord vergeten",
    "Forgot your password? ": "Wachtwoord vergeten?",
    "Have an account? ": "Heb je een account?",
    "Incorrect username or password": "Gebruikersnaam of wachtwoord is onjuist",
    "Invalid code received for user": "Ongeldige code ontvangen voor gebruiker",
    "Invalid password format": "Ongeldig wachtwoord",
    "Invalid phone number format": "Ongeldig telefoonnummer",
    "Loading": "Laden",
    "Lost your code? ": "Ben je je code kwijt?",
    "New Password": "Nieuw wachtwoord",
    "No account? ": "Geen account?",
    "Password": "Wachtwoord",
    "Password attempts exceeded": "Aantal wachtwoordpogingen overschreden",
    "Phone Number": "Telefoonnummer",
    "Please confirm your password": "Bevestig uw wachtwoord",
    "Remember this device": "Onthoud dit apparaat",
    "Resend Code": "Code opnieuw sturen",
    "Reset password": "Wachtwoord opnieuw instellen",
    "Reset your password": "Stel je wachtwoord opnieuw in",
    "Send Code": "Code sturen",
    "Set MFA": "Schakel MFA in",
    "Sign In": "Inloggen",
    "Sign Out": "Uitloggen",
    "Sign Up": "Aanmelden",
    "Sign in": "Inloggen",
    "Sign in to your account": "Log in op je account",
    "Skip": "Overslaan",
    "Submit": "Verzenden",
    "User already exists": "Gebruiker bestaat al",
    "User does not exist": "Gebruiker bestaat niet",
    "User does not exist.": "Gebruiker bestaat niet.",
    "Username": "Gebruikersnaam",
    "Username cannot be empty": "Gebruikersnaam moet ingevuld zijn",
    "Username/client id combination not found.": "Combinatie gebruikersnaam/klantnummer niet gevonden.",
    "Verification Code": "verificatiecode",
    "Verify": "Controleren",
    "Verify Contact": "Contact controleren",
    "Verify Token": "Controleer token"
  },
  "authentication": {
    "link-corporate": "Ga naar",
    "verification_message": "We hebben een bevestigingscode naar je e-mailadres gestuurd.",
    "warning": {
      "requires-mfa": "Alleen gebruikers die multifactor-authenticatie hebben ingeschakeld kunnen hun bestellingen beheren. Je kunt multifactor-authenticatie instellen in: "
    }
  },
  "brand": {
    "name": "Lamb Weston"
  },
  "claims": {
    "column": {
      "amount": "Billback-bedrag",
      "contract-no": "Contractnr.",
      "description": "Omschrijving",
      "info": "Info",
      "posting-date": "Datum",
      "status": "Status",
      "type": "Type"
    },
    "empty": "Geen claims beschikbaar",
    "header": {
      "intro": "Bekijk uw huidige claims.",
      "title": "Overzicht van ingediende claims"
    },
    "kg": "KG",
    "new": {
      "confirm-dialog": {
        "button": "Bericht sluiten",
        "message": "Geachte klant, hartelijk dank voor uw invoer. Uw claim wordt beoordeeld en binnen 3 tot 4 weken afgehandeld. Neem bij vragen contact op met uw commerciële contactpersoon bij LW/M.",
        "title": "Uw claim is ingediend"
      },
      "footer": {
        "back": "Terug",
        "next": "Volgende",
        "submit": "Claim indienen",
        "total-billback-amount": "Totaal Billback-bedrag",
        "total-claim-amount": "Totaal claimbedrag: ",
        "total-volume": "Totaal volume: "
      },
      "items": {
        "bags": "Zakken",
        "billback-amount": "Billback-bedrag",
        "billback-rate": "Billback-tarief",
        "boxes": "Dozen",
        "volume": "Volume"
      },
      "new-claim-button": "Nieuwe claim indienen",
      "repeat-button": {
        "large1": "Wilt u een andere claim starten?",
        "large2": "Terug naar claimoverzicht",
        "small": "Claimoverzicht"
      },
      "steps": {
        "claim-details": "Claimgegevens invullen",
        "claim-summary": "Claimoverzicht",
        "details": {
          "agreement-details": "Gegevens van de overeenkomst",
          "applicant": "Aanvrager",
          "currency": "Valuta:",
          "header": "Claimgegevens",
          "valid-range": "Geldig van-tot: {from} tot {to}",
          "wholesale-party": "Groothandel"
        },
        "details-form": {
          "credit-reference": {
            "label": "Kredietreferentie",
            "placeholder": "Vul uw kredietreferentie in"
          },
          "header": "Claimgegevens invullen",
          "intro": "Selecteer de producten voor uw kortingsclaim. Wij verzoeken u ook de groothandel op te geven waar u uw producten hebt besteld.",
          "period": {
            "clear": "Wissen",
            "label": "Claimperiode van - tot",
            "placeholder": "Selecteer uw claimperiode"
          },
          "wholesale-party": {
            "label": "Groothandel",
            "placeholder": "Vul uw groothandel in"
          }
        },
        "proof": {
          "attachment": {
            "label": "Lever een aankoopbewijs aan voor alle hierboven toegevoegde artikelen",
            "placeholder": "Sleep bestanden hierheen of klik om te uploaden.  (max. 25 MB) {'|'} PDF, JPG, PNG, XLSX, DOCX, MSG ondersteund"
          },
          "header": "Bewijs aanleveren"
        },
        "summary": {
          "header": "Samenvatting van uw claim ",
          "your-billback-claim": "Uw Billback-claim"
        }
      }
    },
    "overview": {
      "details": {
        "footer-message": "Neem bij vragen contact op met uw commerciële contactpersoon bij LW EMEA.",
        "title": "Claimoverzicht"
      }
    },
    "search-bar": {
      "placeholder": {
        "search": "Zoeken..."
      },
      "total": "Totaal"
    },
    "status": {
      "failed": "Mislukt",
      "submitted": "Ingediend"
    }
  },
  "container-calculation": {
    "button": {
      "back": "Ga terug",
      "calculate": "Berekenen",
      "download": "Downloaden",
      "next": "Volgende"
    },
    "download": {
      "download": "Je orderberekening downloaden ",
      "file-type": "CSV-bestand",
      "intro": {
        "done": "Je containerorderberekening is gereed!",
        "download": "Je kunt je containerberekening als CSV-bestand downloaden."
      },
      "title": "Orderberekening als CSV-bestand downloaden"
    },
    "header": {
      "intro": {
        "step-1": "Selecteer of je slipsheets of pallets voor je containerbestelling wilt gebruiken.",
        "step-2": "Voeg de gewenste producten toe.",
        "step-3": "Het systeem berekent of er extra opvulartikelen nodig zijn om de containerruimte maximaal te vullen."
      },
      "title": "Selecteer producten voor container"
    },
    "load-base": {
      "pallet": "Pallets",
      "sheet": "Sheets"
    },
    "result": {
      "filled": {
        "description": "klik op Volgende om verder te gaan",
        "message": "Je huidige productselectie past in een container "
      },
      "initial": {
        "description": "",
        "message": "We helpen je om de container tot de maximaal beschikbare ruimte te vullen. Voer het aantal pallets in en klik op Berekenen. Zo nodig zal de calculator feedback geven over het optimaliseren van de containerruimte."
      },
      "overfilled": {
        "description": "We hebben je een voorstel gedaan op basis van het artikel met de grootste hoeveelheid. Je kunt deze suggestie accepteren door op de oranje knop te klikken. Je bent vrij om andere aanpassingen te doen door de hoeveelheid van een artikel in de lijst te wijzigen. Klik op Volgende als de volledige containerruimte is gevuld.",
        "message": "Om de container tot de maximale capaciteit te vullen, moeten er pallets worden verwijderd."
      },
      "overfilled-no-product": {
        "description": "Je huidige productselectie past niet in de beschikbare containerruimte. Reduceer je productselectie met {count} pallets.",
        "message": "Je hebt teveel pallets toegevoegd."
      },
      "totals": {
        "boxes": "Dozen:",
        "kg": "kg",
        "pallets": "Pallets:",
        "title": "Totaal",
        "weight": "Geschat brutogewicht:"
      },
      "underfilled": {
        "description": "We hebben je een voorstel gedaan op basis van het artikel met de grootste hoeveelheid. Je kunt deze suggestie accepteren door op de oranje knop te klikken. Je bent vrij om andere aanpassingen te doen door de hoeveelheid van een artikel in de lijst te wijzigen. Klik op Volgende als de volledige containerruimte is gevuld.",
        "message": "Om de container tot de maximale capaciteit te vullen, moeten er pallets worden toegevoegd."
      }
    },
    "steps": {
      "select-products": "Selecteer producten voor container",
      "summary": "Orderberekening als CSV-bestand downloaden"
    },
    "suggestion": {
      "add": "{amount} toevoegen",
      "reduce": "{amount} verwijderen"
    }
  },
  "contracts": {
    "contract": {
      "general": {
        "contract-no": "Contractnr.:",
        "to": "aan",
        "total-volume": "Totaal contractvolume:",
        "valid-from-to": "Geldig van/tot"
      }
    },
    "disclaimer": {
      "block-1": {
        "content": "Als gevolg van marktveranderingen kan de informatie in je volumecontracten wijzigen. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam vestibulum, sapien eu congue venenatis, orci sem euismod felis, at consectetur dui massa id felis. Nulla et odio felis. Ut congue in neque ut pretium. Etiam elementum, ligula eu consequat varius, nisi risus ultricies libero, sed tristique enim nibh at velit. Fusce facilisis sed augue sed maximus. Quisque non leo tempor, elementum tellus accumsan, hendrerit risus. Nam nec efficitur lorem. Quisque vitae eros diam.",
        "title": "Marktveranderingen"
      },
      "block-2": {
        "content": "Etiam vestibulum, sapien eu congue venenatis, orci sem euismod felis, at consectetur dui massa id felis. Nulla et odio felis. Ut congue in neque ut pretium. Etiam elementum, ligula eu consequat varius, nisi risus ultricies libero, sed tristique enim nibh at velit.",
        "title": "Productwisseling in contracten\n"
      },
      "button": "Ga naar mijn volumecontracten",
      "card": {
        "link": "disclaimer",
        "text": "Lees onze disclaimer voor meer informatie over mogelijke wijzigingen in dit overzicht"
      },
      "need-help": {
        "content": "Heb je nog meer vragen of wil je gedetailleerdere informatie over je volumecontracten? Neem dan contact op met je {link}.",
        "link": "contactpersoon of afdeling Customer Experience",
        "title": "Hulp nodig?"
      },
      "title": "Disclaimer"
    },
    "download": {
      "button": "Downloaden",
      "label": "Selecteer de contractinformatie die je wilt downloaden"
    },
    "header": {
      "intro": "Krijg inzicht in je contracten. Neem bij vragen gerust contact met ons op.",
      "title": "Mijn volumecontracten"
    },
    "products": {
      "header": {
        "billed-qty": "Gefactureerde hoeveelheid in kg",
        "code": "LW-code",
        "contract-qty": "Contracthoeveelheid in kg",
        "kg-left": "kg over",
        "material": "Materiaal",
        "open-orders": "Openstaande bestellingen in kg",
        "percent-left": "% over",
        "product": "Productnaam"
      }
    }
  },
  "dashboard": {
    "invoices": {
      "go-to-my-invoices": "Ga naar mijn facturen",
      "my-invoices": "Mijn facturen",
      "open-invoices": "Openstaande facturen",
      "upcoming": "Komende",
      "your-open-invoices": "Je openstaande facturen"
    },
    "orders": {
      "go-to-orders-overview": "Ga naar het overzicht bestellingen & leveringen",
      "last-order": "Laatste bestelling",
      "my-orders-deliveries": "Mijn bestellingen & leveringen",
      "no-last-order": "Geen laatste bestelling beschikbaar",
      "order-date": "Besteldatum",
      "order-status": "Bestelstatus",
      "your-orders-deliveries": "Je bestellingen & leveringen"
    }
  },
  "e-learning": {
    "action": {
      "continue": "Verdergaan",
      "enroll": "Inschrijven",
      "view": "Bekijken"
    },
    "course": {
      "finish": {
        "button": "Ik heb deze cursus afgerond",
        "description": "Klik op de knop om te registreren dat deze cursus is afgerond.",
        "title": "Heb je de cursus afgerond?"
      },
      "header": {
        "back": "Terug naar overzicht",
        "status": "Status:"
      },
      "related": {
        "default-title": "Andere cursussen"
      }
    },
    "minutes": "minuten",
    "overview": {
      "empty": "Geen cursussen gevonden",
      "search-bar": {
        "category": {
          "all": "Alle",
          "placeholder": "Categorie: Alle"
        },
        "duration": {
          "all": "Alle",
          "more-than": "Meer dan",
          "placeholder": "Duur: Alle"
        },
        "result-title": "({count}) Zoekresultaten voor: | ({count}) Zoekresultaat voor: | ({count}) Zoekresultaten voor: ",
        "search": {
          "placeholder": "Zoeken..."
        },
        "status": {
          "all": "Alle",
          "placeholder": "Status: Alle"
        }
      },
      "title": "E-learning"
    },
    "status": {
      "completed": "Afgerond",
      "in-progress": "Bezig",
      "not-started": "Nog niet begonnen"
    }
  },
  "eatThis": {
    "download": "nu downloaden",
    "open": "nu openen"
  },
  "error": {
    "error_404": {
      "title": "oeps, pagina niet gevonden"
    },
    "error_500": {
      "title": "oeps, fout 500"
    },
    "general": {
      "subtitle": "het lijkt erop dat deze pagina niet werkt",
      "title": "oeps, onbekende fout"
    }
  },
  "footer": {
    "copyright": "© {year} Alle rechten voorbehouden Lamb Weston",
    "navigation": {
      "privacy": "Privacy",
      "profile": "Profiel",
      "terms-and-conditions": "Algemene voorwaarden"
    }
  },
  "general": {
    "for": "voor",
    "interface": {
      "back": "Terug",
      "cancel": "Annuleren",
      "close": "Sluiten",
      "remove": "Verwijderen",
      "save": "Opslaan",
      "update": "Update",
      "none": "Geen",
      "noResultsFound": "Geen resultaten gevonden",
      "all": "Alle",
      "create": "Creëren",
      "next": "Volgende"
    },
    "locale": {
      "de": "Duits",
      "en-GB": "Engels",
      "es": "Spaans",
      "fr": "Frans",
      "it": "Italiaans",
      "nl": "Nederlands"
    },
    "messages": {
      "error": "Er is een onverwachte fout opgetreden."
    },
    "table": {
      "not-available": "niet beschikbaar"
    },
    "dialog": {
      "confirm_delete_message": "Weet u zeker dat u dit item wilt verwijderen?"
    }
  },
  "home": {
    "intro": "Bij het klantenportaal van Lamb Weston.",
    "title": "Welkom{fullname},",
    "subtitle": "Met trots bedienen wij {customerName}"
  },
  "invoices": {
    "column": {
      "amount": "Aantal",
      "details": "Info",
      "expire-date": "Vervaldatum",
      "invoice-nr": "Factuurnr.",
      "posting-date": "Boekingsdatum",
      "sales-order": "Verkooporder",
      "sales-order-show": "tonen",
      "status": "Status"
    },
    "detail": {
      "label": {
        "amount": "Aantal",
        "currency": "Valuta",
        "expire-date": "Vervaldatum",
        "invoice-number": "Factuurnummer",
        "order-reference": "Bestelreferentie",
        "payment-terms-code": "Code betalingsvoorwaarden",
        "payment-terms-description": "Beschrijving betalingsvoorwaarden",
        "posting-date": "Boekingsdatum",
        "relevant-bill-to": "Betreffende rekening naar",
        "relevant-payer": "Betreffende betaler",
        "sales-order-ship-to": "Verkooporder verzenden naar",
        "type-commercial": "Type zakelijk"
      },
      "pdf-download": "PDF factuur downloaden",
      "sales-order": {
        "close": "Bericht sluiten",
        "order-overview": "Ga naar mijn bestellingen",
        "title": "Factuur {invoice} - Verkooporder"
      },
      "show-sales-order": "verkooporder tonen"
    },
    "empty": "Geen facturen beschikbaar",
    "header": {
      "intro": "Op deze pagina kun je je facturen vinden en downloaden. Klik op een rij voor meer informatie.",
      "title": "Mijn facturen"
    },
    "search-bar": {
      "placeholder": {
        "all-invoices": "Alle facturen",
        "filter": "Facturen filteren",
        "search": "Zoeken..."
      },
      "total": "Totaal",
      "total-filtered": "Totaal gefilterd"
    },
    "status": {
      "before due": "openstaande betaling",
      "cleared": "betaald",
      "days-till-due-date": "{count} dagen|{count} dag|{count} dagen",
      "due date": "vervaldatum",
      "overdue": "overschreden",
      "reversed": "teruggestuurd"
    }
  },
  "menuEngineering": {
    "categories": {
      "laggard": "achterblijver",
      "runner": "hardloper",
      "sleeper": "slaper",
      "winner": "winnaar"
    },
    "imageAlt": {
      "icon": "Pictogram categorie chef",
      "laggard": "Chef categorie achterblijver",
      "runner": "Chef categorie hardloper ",
      "sleeper": "Chef categorie slaper ",
      "winner": "Chef categorie winnaar "
    },
    "label": {
      "addDishEquation": "Je gerecht is toegevoegd aan de vergelijking",
      "categoryResult": {
        "intro": "Hieronder vind je de resultaten van jouw gerechten in de vier categorieën van",
        "link": "menu-ontwerp",
        "outro": "Klik op de categorie om te zien welke van jouw gerechten in die categorie vallen en ontvang tegelijk advies over het optimaliseren van jouw gerechten."
      },
      "companySeatCount": "Hoeveel stoelen heb je?",
      "companyStaffSize": "Hoe groot is jouw personeelsbestand?",
      "cost": "Kosten etenswaren (€)",
      "course": {
        "breakfast": "Ontbijt",
        "dinner": "Avondeten",
        "inbetween": "Tussendoor",
        "lunch": "Lunch",
        "snack_time": "Snacktijd"
      },
      "courseDish": "Cursus",
      "dishNotDeleted": "Gerecht kan niet worden verwijderd",
      "editDish": "Je gerecht is bewerkt",
      "goodCalculation": "We hebben minimaal 5 gerechten nodig om een goede berekening te kunnen maken.",
      "helpTime": "Tijd keukenhulp (min)",
      "info": {
        "cost": "De totale kostprijs van alle ingrediënten in het gerecht.",
        "helpTime": "Tijd besteed door keukenpersoneel aan het bereiden van dit gerecht.",
        "popularity": "Hoeveel stuks van dit gerecht worden er per week verkocht.",
        "price": "De verkoopprijs van het gerecht op het menu, vóór belastingen.",
        "time": "Tijd besteed door de chef aan het bereiden van dit gerecht."
      },
      "insufficientDishes": "We hebben nog tenminste {count} gerechten nodig om een goede berekening te kunnen maken.",
      "laggard": {
        "demand": "Weinig vraag",
        "profit": "Lage winst"
      },
      "laggards": "Achterblijvers",
      "nameOfDish": "Naam van het gerecht",
      "optionRestaurant": "Restaurant",
      "popularity": "Populariteit (aantal per week)",
      "price": "Verkoopprijs excl. btw (€)",
      "runner": {
        "demand": "Hoge vraag",
        "profit": "Lage winst"
      },
      "runners": "Hardlopers",
      "selectCourse": "Cursus",
      "selectCourseLabel": "Kies een cursus",
      "sleeper": {
        "demand": "Weinig vraag",
        "profit": "Hoge winst"
      },
      "sleepers": "Slapers",
      "thinkOfYourDish": "Denk aan een van je gerechten. En vul het formulier in.",
      "time": "Tijd chef (min)",
      "typeOfRestaurant": "Wat voor soort restaurant heb je?",
      "winner": {
        "demand": "Hoge vraag",
        "profit": "Hoge winst"
      },
      "winners": "Winnaars"
    },
    "overview": {
      "addAnotherDish": "Opslaan en nog een toevoegen",
      "addDish": "Voeg een gerecht toe",
      "addDishEquation": "Voeg een gerecht toe aan de vergelijking",
      "calculateNow": "Bereken nu",
      "cancel": "Annuleren",
      "categoryCompare": "Vergeleken met andere gerechten binnen jouw markt, lijkt je gerecht een",
      "categoryResult": {
        "intro": "Dit zijn de",
        "outro": "gangen van je menu"
      },
      "deleteProfile": "Je staat op het punt je profiel te verwijderen",
      "dishes": "Gerechten",
      "menuEngineering": "Menu-ontwerp",
      "results": "Resultaten",
      "save": "Opslaan",
      "showResults": "Toon de resultaten",
      "startMenuEngineering": "Begin met het ontwerpen van je menu",
      "testValueDishes": "Test de waarde van je gerechten",
      "typeOfRestaurant": "Soort restaurant",
      "yourDish": "Jouw gerecht"
    },
    "placeholder": {
      "typeOfRestaurant": "bijv. steakhouse, pizzeria, enz"
    },
    "results": {
      "back-to-results": "Terug naar mijn resultaten",
      "title": "Resultaten van mijn menu-ontwerp"
    },
    "try-out": {
      "dish-form": {
        "subtitle": "Denk aan een van je gerechten. En vul het formulier in.",
        "title": "2. Jouw gerecht"
      },
      "hero": {
        "subtitle": "Menu-ontwerp helpt bij het evalueren van jouw gerechten op het menu en om een overzicht te krijgen van je beste en slechtste presteerders.",
        "title": "Test de echte waarde van je gerechten"
      },
      "intro": {
        "text": "Menu-ontwerp vergelijkt de gerechten ten opzichte van elkaar. Je hebt dus altijd winnaars, slapers, hardlopers en achterblijvers. Om een goed resultaat te krijgen, vergelijk je alleen vergelijkbare gerechten van het menu, zoals het segment \"Hoofdgerechten\".",
        "title": "Menu-ontwerp",
        "try": "Probeer het hieronder voor één gerecht!"
      },
      "restaurant-type": {
        "label": "Kun je ons vertellen welk restaurant?",
        "subtitle": "Wat voor soort restaurant heb je?",
        "title": "1. Soort restaurant"
      },
      "result": {
        "sign-up": "Doe mee om je gerechten te vergelijken"
      }
    }
  },
  "navigation": {
    "approved-products": "{company} portfolio",
    "back-to-overview": "Terug naar het overzicht",
    "best-practices": "Optimale werkwijzen/Draaiboek",
    "container-calculation": "Containerberekening",
    "dashboard": "Dashboard",
    "e-learning": "E-learning",
    "eat-this": "Eat This!",
    "lwm-company-information": "Lamb Weston-bedrijf",
    "lwm-contact": "Lamb Weston-contacten",
    "market-activations": "Marktactivaties",
    "menu-engineering": {
      "add-dish": "Voeg gerecht toe",
      "main": "Menu-engineering",
      "my-results": "Mijn resultaten",
      "try-out": "Test de werkelijke waarde van je gerechten"
    },
    "my-agreements": "Mijn overeenkomsten",
    "my-claims": "Mijn claims",
    "my-invoices": "Mijn facturen",
    "my-orders": "Mijn bestellingen & leveringen",
    "my-volume-contracts": "Mijn volumecontracten",
    "new-products": "Innovaties & trends",
    "partnership": "{company} partnerschap",
    "permission-mgt": "Machtigingsbeheer",
    "product-information": "Productinformatie",
    "products-for": "{company} portfolio",
    "settings": {
      "main": "Instellingen",
      "my-profile": "Mijn profiel"
    },
    "sign-out": "Uitloggen",
    "sustainability": "Duurzaamheidsagenda",
    "training": "Operatie & training",
    "trend-information": "Trendinformatie",
    "user-management": "Gebruikersbeheer",
    "dock-scheduler": "Dockplanner",
    "dock-scheduler-booking": "Boekingsoverzicht",
    "dock-scheduling-rules": "Dockplanningsregels"
  },
  "onboarding": {
    "authenticator": {
      "error": {
        "InvalidParameterException": "De validatiecode moet uit 6 tekens bestaan.",
        "unknown": "Er is een fout opgetreden, probeer het nog een keer."
      },
      "finish": "Voltooien",
      "qr-description": "Scan de QR-code met je authenticatie-app om de MFA-code te ontvangen.",
      "qr-title": "MFA-code",
      "step-title": "Stel de authenticatietoken in",
      "steps": "Download de Google Authenticator-app in de Apple of Android Store|Druk op het '+'-pictogram|Selecteer 'Scan QR-code'|Voer de code van de app in het veld 'Verificatiecode' in.",
      "title": "Authenticator-app"
    },
    "change-mfa": "Wijzigen",
    "finished": {
      "features-enabled": "Alle portaalfuncties zijn nu beschikbaar.",
      "finish": "Ga naar het dashboard",
      "intro": {
        "authenticator": "Bedankt voor het instellen van je multi-factorauthenticatie.\nVanaf nu kun je je aanmelden met multi-factorauthenticatie via je authenticator-app.",
        "sms": "Bedankt voor het instellen van je multi-factorauthenticatie.\nVanaf nu kun je je aanmelden met multi-factorauthenticatie via een sms-bericht op je telefoon."
      },
      "title": "Authenticatie geverifieerd!"
    },
    "mfa-preference": "Voorkeur multi-factorauthenticatie",
    "none": {
      "description": "Wanneer je geen multi-factorauthenticatiemethode (MFA) instelt, kun je alleen de functionaliteiten in het klantenportaal gebruiken die deze niet vereisen. Als je doorgaat zonder MFA in te stellen, dan krijg je deze pop-up bij je volgende bezoek weer te zien.",
      "finish": "Zonder MFA gebruiken",
      "title": "MFA niet inschakelen"
    },
    "sms": {
      "change-phone": "Telefoonnummer wijzigen",
      "code-sent": "We hebben een code naar je telefoon gestuurd.",
      "finish": "Voltooien",
      "request-code": "Code aanvragen",
      "steps": "Vul je telefoonnummer in en druk op 'Code aanvragen'|Binnen enkele seconden ontvang je een sms met een verificatiecode|Vul de verificatiecode in en druk op 'Voltooien' om te activeren.",
      "title": "Sms-berichten"
    },
    "welcome": {
      "buttons": {
        "authenticator": {
          "label": "(gebruik een QR-code en MFA-app om een authenticatietoken op je mobiele telefoon op te slaan)",
          "type": "Authenticator-app"
        },
        "none": {
          "label": "",
          "type": "MFA niet inschakelen"
        },
        "sms": {
          "label": "(ontvang een code op je mobiele telefoon).",
          "type": "Sms-berichten"
        }
      },
      "explanation-description": "Multi-factorauthenticatie (MFA) zorgt voor een extra beveiligingslaag bovenop het inloggen met je gebruikersnaam en wachtwoord. Geef hierboven een geldig mobiel telefoonnummer op om sms-authenticatie in te schakelen.",
      "explanation-title": "Voorkeur multi-factorauthenticatie",
      "recommend-description": "Om veiligheidsredenen adviseren we je om ook multi-factorauthenticatie te gebruiken.",
      "required-description": "Welkom bij je klantenportaal! Om toegang te krijgen tot alle functies in het klantenportaal is multi-factorauthenticatie vereist. ",
      "title": "Welkom!"
    }
  },
  "orders": {
    "card": {
      "footer": {
        "order-again": "Bestel deze producten opnieuw",
        "reorder": "Wil je deze bestelling herhalen? Klik op de knop 'bestel deze producten opnieuw'.",
        "summary-info": "* De samenstelling van de bestelling kan variëren naargelang de beschikbaarheid van de producten; bevestiging van de producten en aantallen volgt. Lamb Weston en zijn logistieke partners doen hun uiterste best om op de gewenste datum te leveren, maar de werkelijke leverdatum zal op een later moment worden doorgegeven."
      },
      "header": {
        "bill-of-lading": "BoL:",
        "close": "sluiten",
        "container-numbers-long": "({count}) containernummers",
        "container-numbers-short": "NR.",
        "more": "meer",
        "order-city": "Bestemming:",
        "order-date": "Besteldatum: ",
        "order-no": "LW #: ",
        "order-ref": "Bestelref.: ",
        "order-reference": "Bestelreferentie.:",
        "products-to-order": "Producten om te bestellen"
      },
      "status": {
        "delivery-date": "Levering:",
        "label": "Status:",
        "more-info": "meer informatie over bestelstatus"
      }
    },
    "group": {
      "last-order": "Je laatste bestelling",
      "see-products": "klik om producten te zien"
    },
    "header": {
      "intro": "Je kunt hieronder nieuwe bestellingen plaatsen, je ordergeschiedenis bekijken of snel een herhaalde bestelling plaatsen. ",
      "new-order-button": "Nieuwe bestelling plaatsen",
      "title": "Mijn bestellingen"
    },
    "new": {
      "confirm-dialog": {
        "button": "Bericht sluiten",
        "message": "De samenstelling van de bestelling zal worden bevestigd door onze klantenservice. Het kan een minuutje duren voordat je bestelling in het besteloverzicht verschijnt.",
        "title": "Bedankt voor je bestelling bij Lamb Weston"
      },
      "footer": {
        "back": "Ga terug",
        "cancel": "Annuleren",
        "confirm": "Bestelling bevestigen",
        "next": "Volgende",
        "recalculate": "Herberekenen"
      },
      "preferred-warehouse": "**U heeft het magazijn: {code} geselecteerd,** vanwege deze selectie kunt u voor deze bestelling **alleen producten uit dit magazijn bestellen.** Als u producten uit **een ander magazijn** wilt bestellen, maak dan **een aparte bestelling aan.**",
      "help-text": "Productnamen bestaan uit snijmaten en het gewicht van de dozen.",
      "intro": "Je kunt je bestellingen snel en eenvoudig plaatsen. Zodra de bestelling in het systeem is ingevoerd en verwerkt, neemt onze afdeling Customer Experience contact met je op voor de betaal- en leveringsgegevens.",
      "products-title": "Productassortiment Lamb Weston",
      "products-unavailable": {
        "button": "Ga naar productselectie",
        "item-label": "Niet beschikbaar",
        "message": "Je huidige bestelling bevat een product dat niet langer beschikbaar is. Selecteer een alternatief product op het productselectiescherm. We hebben de overige producten van je vorige bestelling aan je bestellijst toegevoegd.",
        "title": "Bestel deze producten opnieuw - {count} product(en) niet beschikbaar"
      },
      "repeat-button": {
        "large1": "Wil je een eerdere bestelling herhalen?",
        "large2": "Ga terug naar besteloverzicht",
        "small": "bestelling herhalen?"
      },
      "steps": {
        "order-reference-and-shipping": "Bestelreferentie & verzending",
        "order-summary-and-confirmation": "Besteloverzicht & bevestiging",
        "select-products": "Producten selecteren"
      },
      "suggest-fill-scale": {
        "footer": {
          "message": "Klik op de oranje knop om te accepteren. U kunt alternatieve aanpassingen doen door de hoeveelheid van elk product in de lijst te wijzigen. U kunt ook onze suggestie negeren en doorgaan naar de volgende stap van het bestelproces.",
          "title": "Wij kunnen uw bestelling optimaliseren! We hebben een suggestie voor u gedaan zodat uw bestelling past binnen de volgende ordervolumeschaal."
        },
        "tooltip": {
          "message": "Voeg **+{quantity}** pallet(s) toe om te profiteren van lagere vrachttarieven.",
          "title": "Wij kunnen uw bestelling optimaliseren!"
        }
      },
      "suggest-fill-truck": {
        "footer": {
          "message": "Klik op de oranje knop om de suggestie te accepteren. U kunt alternatieve aanpassingen doen door de hoeveelheid van elk product in de lijst te wijzigen. U kunt ook onze suggestie negeren en doorgaan naar de volgende stap van het bestelproces.",
          "title": "Wij kunnen uw bestelling optimaliseren! We hebben een suggestie voor u gedaan zodat uw bestelling de vrachtwagen vult."
        },
        "tooltip": {
          "message": "Voeg **+{quantity}** pallet(s) toe om de vrachtwagen te vullen.",
          "title": "Wij kunnen uw bestelling optimaliseren!"
        }
      },
      "suggest-remove": {
        "footer": {
          "message": "We hebben een suggestie voor u gedaan op basis van de bestelregel met de hoogste waarde. Klik op de oranje knop om de suggestie te accepteren. U kunt alternatieve aanpassingen doen door de hoeveelheid van elk product in de lijst te wijzigen. Klik op Herberekenen na het aanpassen van uw bestelling om verder te gaan.",
          "title": "U hebt het maximale laadgewicht voor de vrachtwagen overschreden met {quantity} pallet(s) ({exceededWeight} kg), inclusief pallets."
        },
        "tooltip": {
          "message": "Verminder de hoeveelheid voor dit product met **-{quantity}**. Annuleer om de hoeveelheid voor andere artikelen te verminderen.",
          "title": "U hebt het maximale laadgewicht voor de vrachtwagen overschreden."
        }
      },
      "suggestion": {
        "accept": "Accepteren",
        "cancel": "Annuleren"
      },
      "title": "Nieuwe bestelling"
    },
    "custom-label-switch": {
      "title": "Originele labels weergeven",
      "description": "Dit toont de originele productinformatie die door LambWeston is verstrekt wanneer ingeschakeld.",
      "checkbox": "Originele productnaam en nummer weergeven"
    },
    "order-item-list": {
      "header": {
        "art": "Materiaal",
        "boxes": "Dozen",
        "code": "LW-code",
        "warehouse": "Magazijn",
        "layers": "Lagen",
        "pallets": "Pallets",
        "product": "Product",
        "products": "Producten",
        "quantity": "Aantal",
        "unit-type": "Type eenheid"
      },
      "totals": {
        "grand-total": "Eindtotaal",
        "kg": "kg",
        "total-cartons": "Dozen | Doos | Dozen",
        "total-gross-weight": "Brutogewicht",
        "total-layers": "Lagen | Laag | Lagen",
        "total-net-weight": "Nettogewicht",
        "total-pallets": "Pallets | Pallet | Pallets"
      },
      "unit": {
        "bag": "Zak",
        "car": "Dozen",
        "kg": "kg",
        "lay": "Lagen",
        "pal": "Pallets"
      }
    },
    "overview": {
      "closed-orders-title": "Afgeronde bestellingen",
      "empty": "Geen bestellingen beschikbaar",
      "header": {
        "eta-actual": "werkelijke ETA",
        "eta-booked": "ETA geboekt",
        "eta-requested": "Req. ETA",
        "more": "meer",
        "order-city": "Bestemming",
        "order-date": "Besteldatum",
        "order-no": "LW #",
        "order-ref": "Bestelref.",
        "order-reference": "Bestelreferentie.",
        "order-status": "Bestelstatus"
      },
      "open-orders-title": "Openstaande bestellingen",
      "search-bar": {
        "query": {
          "placeholder": "Zoek naar een specifieke bestelling..."
        },
        "status": {
          "all": "Alle bestellingen",
          "placeholder": "Status bestelling"
        }
      }
    },
    "reference": {
      "intro": "Als je een bestelreferentie/PO-nummer wilt toevoegen voor je bestelling, vul dan het bestelreferentieveld in.",
      "number": {
        "max-characters": "(max 20 tekens)",
        "placeholder": "Voeg je bestelreferentienummer toe",
        "title": "Bestelreferentie"
      },
      "title": "Je bestelreferentie"
    },
    "search-bar": {
      "placeholder": {
        "set-preferred-warehouse": "Voorkeursmagazijn instellen",
        "filter-products": "Producten filteren",
        "search": "Naar een specifiek product zoeken...",
        "search-alt": "zoeken"
      }
    },
    "shipping": {
      "delivery-date": {
        "label": "dit is een geschatte datum",
        "title": "Gewenste leverdatum"
      },
      "eta": {
        "delayed": "vertraagd",
        "early": "vervroegd",
        "eta": "Verwachte aankomsttijd:"
      },
      "ship-to": {
        "title": "Verzenden naar"
      },
      "title": "Verzending"
    },
    "status": {
      "AWS_CREATED": "Ontvangen door Lamb Weston",
      "DELIVERED": "Afgeleverd",
      "SAP_CANCELLED": "Geannuleerd",
      "SAP_CREATED": "Geaccepteerd",
      "SAP_PROCESSING": "Verwerken",
      "SAP_PROCESSING_PART": "Verwerken",
      "SAP_SHIPPED": "Verzonden",
      "SAP_SHIPPED_PART": "Verzonden",
      "SAP_UNKNOWN": "Onbekend",
      "more-info": {
        "AWS_CREATED": "De bestelling is voltooid en bevestigd via het klantenportaal. Er is een bevestigingsmail verstuurd.",
        "DELIVERED": "Bevestiging dat de goederen zijn afgeleverd op locatie",
        "SAP_CANCELLED": "Bestelling is geannuleerd.",
        "SAP_CREATED": "Bestelling is voltooid, uitgaande verzending gemaakt, geen blokkeringen, geen afwijzingen.",
        "SAP_PROCESSING": "Bestelling is verwerkt en gecontroleerd door LW Customer Experience.",
        "SAP_PROCESSING_PART": "Verwerking in SAP, gedeeltelijk geaccepteerde bestelling.",
        "SAP_SHIPPED": "Bestelling is volledig geladen, BGA ontvangen.",
        "SAP_SHIPPED_PART": "SAP-levering aangemaakt, gedeeltelijk geaccepteerde bestelling.",
        "SAP_UNKNOWN": "Neem voor meer informatie contact op met je contactpersoon bij Customer Experience."
      },
      "part": "partly",
      "partly": "niet volledig"
    },
    "summary": {
      "delivery-date": "Verzenden naar en gewenste leverdatum",
      "title": "Samenvatting van je bestelling"
    },
    "warning": {
      "requires-mfa": "Alleen gebruikers die multifactor-authenticatie hebben ingeschakeld kunnen hun bestellingen beheren. Je kunt multifactor-authenticatie instellen in:"
    }
  },
  "permission-mgt": {
    "column": {
      "actions": {
        "delete": "Verwijderen",
        "get": "Lezen",
        "label": "Acties",
        "post": "Aanmaken",
        "put": "Bijwerken",
        "tooltip": "Meer informatie over acties"
      },
      "configure": {
        "label": "Instellen",
        "tooltip": "Meer informatie over instellen"
      },
      "delete": {
        "label": "Verwijderen",
        "tooltip": "Meer informatie over verwijderen"
      },
      "effect": {
        "label": "Effect",
        "tooltip": "Meer informatie over effect"
      },
      "endpoint": {
        "label": "Eindpunt",
        "tooltip": "Meer informatie over eindpunt"
      },
      "field": {
        "label": "Veld"
      },
      "model": {
        "label": "Model"
      },
      "operator": {
        "label": "Beheerder"
      },
      "value": {
        "label": "Waarde"
      },
      "wildcard": {
        "label": "Voor wildcard eindpunt",
        "tooltip": "Meer informatie over wildcard"
      }
    },
    "effect": {
      "allow": "Toestaan",
      "deny": "Weigeren"
    },
    "intro": "Gebruikersrollen en hun machtigingen beheren. Selecteer eerst een rol of voeg een nieuwe rol toe.",
    "policies": {
      "add": "Nieuw beleid toevoegen",
      "configure": {
        "actions": "Acties",
        "effect": "Effect",
        "endpoint": "Eindpunt",
        "for-wildcard-endpoint": "Voor wildcard eindpunt",
        "id": "ID",
        "locale": "Lokaal",
        "title": "Beleid instellen",
        "wildcard": "Wildcard"
      },
      "delete": {
        "cancel": "Annuleren",
        "confirm": "Beleid verwijderen",
        "message": "Weet je zeker dat je dit beleid wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.",
        "success": "Beleid succesvol verwijderd",
        "title": "Beleid verwijderen"
      },
      "intro": "Beleid voor deze rol. Je kunt het beleid voor deze rol instellen door op de knop 'instellen' te drukken en "
    },
    "policy-form": {
      "cancel": "Annuleren",
      "endpoint": {
        "label": "Eindpunt",
        "placeholder": "Selecteer een eindpunt"
      },
      "filters": {
        "add": "Nieuw filter toevoegen",
        "title": "Beleidsfilters"
      },
      "placeholder": {
        "select": {
          "field": "Een veld selecteren",
          "model": "Een model selecteren",
          "operator": "Een beheerder selecteren"
        }
      },
      "submit": "Opslaan & afsluiten",
      "title": "Beleid instellen"
    },
    "role": {
      "add": "Nieuwe rol toevoegen",
      "edit": "Naam van de rol wijzigen",
      "form": {
        "cancel": "Annuleren",
        "error": "Er is een fout opgetreden tijdens het opslaan van de rol",
        "name": {
          "label": "Naam",
          "placeholder": "De naam van de rol invoeren"
        },
        "submit": "Opslaan",
        "success": "De rol is opgeslagen",
        "title": "Rol"
      },
      "placeholder": "Een rol selecteren"
    },
    "select-role": "Selecteer eerst een rol of klik om een nieuwe rol toe te voegen.",
    "title": "Machtigingsbeheer"
  },
  "product-information": {
    "contact": {
      "description": "Wil je informatie over een nieuw product of productinformatie over een product dat niet in je lijst staat?",
      "link": "Neem contact op met de afdeling Customer Experience",
      "subject": "Productinformatie klantenportaal"
    },
    "detail": {
      "intro": "Hier vind je alle beschikbare productinformatie over dit product.",
      "packaging": {
        "cartons": "dozen",
        "cm": "cm",
        "commodity-code": "HS-douanecode",
        "dimensions": "Afmetingen",
        "ean-upc": "EAN-code",
        "gross-weight": "Brutogewicht",
        "height": "hoogte",
        "kg": "kg",
        "layers": "lagen",
        "length": "lengte",
        "material": "Materiaal",
        "net-weight": "Nettogewicht",
        "pallet-type": "Pallettype",
        "shelf-life-code": "Houdbaarheidsdatum",
        "title": "Verpakking & afmetingen",
        "unit": {
          "bag": "Verpakking/zak",
          "car": "Doos",
          "lay": "Laag",
          "pal": "Pallet"
        },
        "width": "breedte"
      },
      "product-sheet": {
        "download-button": "Pdf productblad downloaden",
        "information-list": "Voedingswaarde-informatie|Informatie over allergenen|Bereidingswijze|Voorbeeldinformatie",
        "intro": "In dit commerciële productspecificatieblad kun je de volgende informatie vinden.",
        "subtitle": "Pdf commercieel productspecificatieblad",
        "title": "Productblad"
      }
    },
    "header": {
      "intro": "Hier vind je de beschikbare productinformatie. Klik op 'meer informatie' voor productdetails.",
      "title": "Productinformatie"
    },
    "list": {
      "empty": "Geen producten beschikbaar",
      "header": {
        "details": "meer informatie",
        "download": "pdf downloaden"
      }
    }
  },
  "profile": {
    "account-settings": {
      "edit": "Accountinstellingen wijzigen",
      "title": "Accountinstellingen"
    },
    "edit": "wijzigen",
    "email": {
      "confirmation-code": "Voer je bevestigingscode in"
    },
    "error": {
      "failed": "Er is een fout opgetreden bij het opslaan van je profiel",
      "success": "Je profiel is opgeslagen",
      "wrongPassword": "Je hebt een onjuist wachtwoord ingevoerd"
    },
    "label": {
      "cancel": "Annuleren",
      "change-password": "****************",
      "city": "Stad",
      "country": "Land",
      "edit": "Profiel aanpassen",
      "email": "E-mailadres",
      "firstName": "Voornaam",
      "functionTitle": "Functie",
      "lastName": "Achternaam",
      "locale": "Taal",
      "newPassword": "Nieuw wachtwoord",
      "newPasswordRepeat": "Wachtwoord opnieuw invoeren",
      "oldPassword": "Oud wachtwoord",
      "phone": "Telefoonnummer",
      "restaurantCity": "Stad",
      "restaurantCountry": "Land",
      "restaurantName": "Restaurantnaam",
      "restaurantNumber": "Aantal",
      "restaurantPostalcode": "Postcode",
      "restaurantSeats": "Gastenstoelen",
      "restaurantStreet": "Straat",
      "restaurantTelephone": "Telefoonnummer",
      "restaurantType": "Restauranttype",
      "restaurantWebsite": "Website",
      "save": "Opslaan"
    },
    "locale": {
      "change-success": "Je taal is succesvol gewijzigd"
    },
    "mfa": {
      "current-mfa": "Geïnstalleerd: ",
      "method": {
        "NOMFA": "geen multifactor-authenticatie",
        "SMS": "sms-berichten (ontvang een code op je mobiele telefoon)",
        "TOTP": "eenmalig wachtwoord (met authenticator-app)"
      },
      "mfa-description": "Multifactor-authenticatie (MFA) zorgt voor een extra beveiligingslaag bovenop het inloggen met je gebruikersnaam en wachtwoord. Geef hierboven een geldig mobiel telefoonnummer op om sms-authenticatie in te schakelen",
      "no-mfa-description": "MFA niet inschakelen",
      "setup-mfa": "Voorkeur multifactor-authenticatie",
      "sms-description": "sms-berichten (ontvang een code op je mobiele telefoon). Je telefoonnummer moet correct zijn ingesteld.",
      "token-instructions": "Scan de QR-code met je telefooncamera of authenticatie-app om de MFA-code te ontvangen.",
      "totp-description": "Eenmalig wachtwoord (gebruik een QR-code en MFA-app om een authenticatietoken op je mobiele telefoon op te slaan)",
      "totp-info": {
        "1-select-option": "Selecteer 'Eenmalig wachtwoord' bij bovenstaande optie en klik op 'Schakel MFA in'",
        "2-get-app": "Krijg de {0} voor je mobiele telefoon",
        "2-get-app-link": "Google authenticator-app",
        "3-press-plus": "Druk op het '+'-pictogram",
        "4-select-scan": "Selecteer 'Scan QR-code'",
        "5-enter-code": "Voer de code uit de app in als 'verificatiecode'",
        "title": "Hoe eenmalige wachtwoordverificatie instellen"
      }
    },
    "no-profile-placeholder": "Vul je profielgegevens in voor de optimale klantenportaalervaring. Klik op het pictogram in de rechterhoek om je profiel aan te passen.",
    "password": {
      "change-success": "Je wachtwoord is succesvol gewijzigd",
      "do-not-match": "Wachtwoorden komen niet overeen",
      "invalid": "Het wachtwoord moet aan de volgende vereisten voldoen: Minimale wachtwoordlengte van 6 tekens; hoofdletters (A-Z); kleine letters (a-z); cijfers (0-9)."
    },
    "phone": {
      "invalid-phone-number": "Het opgegeven telefoonnummer is geen geldig telefoonnummer",
      "unknown-error": "Er is iets misgegaan, kan je telefoonnummer niet opslaan"
    },
    "placeholder": {
      "city": "Bijv. Londen, Rome",
      "close": "Sluiten",
      "confirmation-code": "123456",
      "country": "Selecteer je land",
      "email": "mail@chefs.network",
      "functionTitle": "Bijv. chef, sous-chef enz.",
      "number": "Bijv. 9, appartement 12 enz.",
      "open": "Opening",
      "password": "Wachtwoord",
      "phone": "555-3891203812",
      "restaurant": {
        "seats": "bijv. 100",
        "type": "bijv. steakhouse, pizzeria, enz"
      },
      "staff": "Bijv. 2",
      "street": "Bijv. Hoofdstraat",
      "zip": "Bijv. 1234 AB, 5678 CD"
    },
    "restaurant": {
      "add": "Nog een restaurant toevoegen",
      "address": "Adres",
      "basic": "Basis",
      "delete": {
        "confirm": "Restaurant verwijderen",
        "message": "Weet je zeker dat je dit restaurant wilt verwijderen?",
        "success": "Je restaurant is verwijderd",
        "title": "Je staat op het punt een restaurant te verwijderen"
      },
      "delete-success": "Je restaurant is verwijderd",
      "edit": "Restaurantinformatie bewerken",
      "save-success": "Je restaurant is opgeslagen",
      "seats": "gastenstoelen",
      "title": "Restaurantinformatie",
      "type": {
        "(mountain) huts": "(Berg)hutten",
        "american diner": "American diner",
        "american_diner": "American diner",
        "bar": "Bar",
        "beach resorts": "Strandresorts",
        "beach_resorts": "Strandresorts",
        "bistro": "Bistro",
        "camp sites": "Campings",
        "camp_sites": "Campings",
        "chicken restaurant": "Kiprestaurant",
        "chicken_restaurant": "Kiprestaurant",
        "fast food": "Fastfood",
        "fast_food": "Fastfood",
        "fish Burger": "Visburger",
        "fish_burger": "Visburger",
        "gourmet restaurant": "Gourmet restaurant",
        "gourmet_restaurant": "Gourmet restaurant",
        "grill restaurant": "Grillrestaurant",
        "grill_restaurant": "Grillrestaurant",
        "hamburger Restaurant": "Hamburgerrestaurant",
        "hamburger_restaurant": "Hamburgerrestaurant",
        "mountain_huts": "(Berg)hutten",
        "other": "Andere",
        "pizza restaurant": "Pizzarestaurant",
        "pizza_restaurant": "Pizzarestaurant",
        "pub": "Pub",
        "seafood restaurant": "Visrestaurant",
        "seafood_restaurant": "Visrestaurant",
        "snack bar": "Snackbar",
        "snack_bar": "Snackbar",
        "steakhouse": "Steakrestaurant"
      }
    },
    "title": "Profiel"
  },
  "registration": {
    "label": {
      "password": "Wachtwoord",
      "restaurantName": "Geef de naam op van het restaurant waarvoor je het menu-ontwerp wilt berekenen."
    },
    "placeholder": {
      "restaurantName": "Restaurantnaam"
    }
  },
  "updates-modal": {
    "general": {
      "close": "Sluiten"
    },
    "scopes": {
      "new-product-cold-store": {
        "button-text": "Update! Nieuwe functies.",
        "read-more": "Lees meer",
        "title": "Update! Nieuwe functies.",
        "content": [
          {
            "title": "Beste klant,",
            "content": "Wij hebben een aantal wijzigingen door gevoerd in ons Customer Portal. Ten eerste is er nu de mogelijkheid om uw materiaalnummer en de daarbij behorende omschrijving te tonen. Bij ons bekende beschrijvingen zullen vanaf nu al getoond worden. Mist u nog een omschrijving geef dit dan door aan uw contactpersoon binnen Lamb Weston.",
            "image": "/img/updates/new-product-cold-store/nl/1.jpg"
          },
          {
            "content": "Wilt u tijdens het bestel proces toch alleen de Lamb Weston beschrijvingen zien dan kunt dat doen door het onderstaande vinkje aanzetten.",
            "image": "/img/updates/new-product-cold-store/nl/2.jpg"
          },
          {
            "content": "Daarnaast tonen wij vanaf heden ook de plaatsnaam van het magazijn waaruit geleverd wordt.",
            "image": "/img/updates/new-product-cold-store/nl/3.jpg"
          },
          {
            "content": "Mocht u nog andere vragen hebben naar aanleiding van de doorgevoerde wijziging neem dan contact op met uw contactpersoon binnen Lamb Weston."
          }
        ]
      }
    }
  },
  "user-management": {
    "add": {
      "email": {
        "label": "E-mailadres",
        "placeholder": "Het e-mailadres van de gebruiker…"
      },
      "error-message": "Er is een fout opgetreden bij het toevoegen van de gebruiker.",
      "intro": "Vul onderstaande gegevens in en klik op de knop 'gebruiker toevoegen' om een nieuwe gebruiker toe te voegen.",
      "locale": {
        "label": "Taal",
        "placeholder": "Selecteer de voorkeurstaal"
      },
      "mfa": {
        "phone": "Telefoonnummer",
        "title": "Voorkeur multifactor-authenticatie",
        "use-sms-mfa": "sms-berichten (ontvang een code op je mobiele telefoon)"
      },
      "sap-id": {
        "customer": "Klant:",
        "label": "SAP-ID",
        "no-portal-access": "Deze klant heeft geen toegang tot het klantenportaal.",
        "placeholder": "SAP-ID bestaat uit max. 12 tekens...",
        "unknown-sap-id": "Onbekend SAP-ID"
      },
      "success-message": "De gebruiker is succesvol toegevoegd.",
      "user-group": {
        "label": "User group",
        "placeholder": "Selecteer de gebruikersgroep"
      }
    },
    "add-new-user": "Nieuwe gebruiker toevoegen",
    "change-roles": {
      "form": {
        "cancel": "Annuleren",
        "error": "De gebruikersrollen konden niet worden opgeslagen",
        "label": "Veranderrol(len)",
        "placeholder": "Een rol toevoegen",
        "remove": "Deze rol verwijderen",
        "submit": "Opslaan",
        "success": "De gebruikersrollen zijn succesvol opgeslagen"
      }
    },
    "change-user-group": {
      "form": {
        "cancel": "Annuleren",
        "error": "De gebruikersgroep kan niet gewijzigd worden",
        "group": {
          "administrators": "Beheerder",
          "any": "Elk",
          "direct-customers": "Directe klant",
          "end-users": "Eindgebruikers",
          "indirect-customers": "Indirecte klant",
          "multinationals": "Multinationaal",
          "none": "Geen",
          "dock-scheduling-users": "Dockplanninggebruiker",
          "dock-scheduling-employees": "Dockplanning medewerker"
        },
        "label": "Gebruikersgroep wijzigen",
        "submit": "Opslaan",
        "success": "De gebruikersgroep is succesvol gewijzigd"
      }
    },
    "column": {
      "customer": "Klant",
      "details": "Wijzigen",
      "email": "E-mail",
      "first-name": "Voornaam",
      "last-name": "Achternaam",
      "status": "Status",
      "user-group": "User group",
      "vendor": "Partner"
    },
    "details": {
      "change-roles": "Wijzig rollen",
      "change-user-group": "Wijzig gebruikersgroep",
      "impersonate": "Deze gebruiker nabootsen",
      "language": "Taal:",
      "manage-user-intro": "Je kunt dit gebruikerswachtwoord of de twee-factor-authenticatie opnieuw instellen door op onderstaande knoppen te klikken.",
      "manage-user-title": "Deze gebruiker beheren",
      "reset-mfa": "Reset 2FA",
      "reset-password": "Wachtwoord opnieuw instellen",
      "sap-id": "SAP-ID:",
      "sap-id-error": "De SAP-ID kan niet worden gewijzigd",
      "sap-id-placeholder": "SAP-ID toevoegen",
      "sap-id-success": "De SAP-ID is gewijzigd",
      "status": {
        "active": "Actief",
        "inactive": "Inactief"
      },
      "toggle-active-intro": "Door onderstaande schakelaar om te zetten kun je de gebruiker activeren of deactiveren.",
      "toggle-active-title": "Gebruiker activeren & deactiveren"
    },
    "group": {
      "administrators": "Beheerders",
      "direct-customers": "Directe klanten",
      "end-users": "Eindgebruikers",
      "indirect-customers": "Indirecte klanten",
      "dock-scheduling-users": "Dockplanninggebruiker",
      "dock-scheduling-employees": "Dockplanning medewerker"
    },
    "group-short": {
      "administrators": "Admin",
      "any": "Elk",
      "direct-customers": "Directe klant",
      "end-users": "Eindgebruikers",
      "indirect-customers": "Indirecte klant",
      "multinational": "Multinationaal",
      "none": "Geen",
      "dock-scheduling-users": "Dockplanninggebruiker",
      "dock-scheduling-employees": "Dockplanning medewerker"
    },
    "impersonate": {
      "bar": {
        "impersonating_as": "Je doet je momenteel voor als",
        "stop": "Stop met nabootsen"
      },
      "dialog": {
        "cancel": "Annuleren",
        "confirm": "Imiteren",
        "message": "Weet je zeker dat je \"{email}\" wilt imiteren?",
        "title": "Imiteer gebruiker"
      }
    },
    "intro": "Beheer je gebruikers. Klik op een gebruikersrij voor meer info of mogelijke gebruikersacties.",
    "reset-mfa": {
      "cancel": "Annuleren",
      "confirm": "Bevestigen",
      "error": "Er is een fout opgetreden bij het opnieuw instellen van de twee-factor-authenticatie.",
      "message": "Weet je zeker dat je de twee-factor-authenticatie voor deze gebruiker opnieuw wilt instellen?",
      "success": "De twee-factor-authenticatie is opnieuw ingesteld.",
      "title": "Twee-factor-authenticatie opnieuw instellen"
    },
    "reset-password": {
      "cancel": "Annuleren",
      "confirm": "Bevestigen",
      "error": "Er is een fout opgetreden bij het opnieuw instellen van het wachtwoord.",
      "message": "Weet je zeker dat je het wachtwoord voor deze gebruiker opnieuw wilt instellen?",
      "success": "Het wachtwoord is opnieuw ingesteld.",
      "title": "Wachtwoord opnieuw instellen"
    },
    "search-bar": {
      "placeholder": {
        "all-user-groups": "All user groups",
        "search": "Zoeken...",
        "search-alt": "zoeken",
        "users": "Gebruikers"
      }
    },
    "status": {
      "active": "actief",
      "cancel": "Annuleren",
      "confirm": "Bevestigen",
      "inactive": "inactief",
      "message": "Weet je zeker dat je de status van de gebruiker wilt wijzigen?",
      "title": "Gebruiker activeren & deactiveren"
    },
    "title": "Gebruikersbeheer",
    "update-vendor-button": "Partner bijwerken",
    "vendor-label": "Partner",
    "vendor-tooltip": "Er is momenteel geen directe integratie met het SAP-systeem van de leverancier. \nDoor een waarde in te stellen, kan een beheerder boekingen voor deze partner maken op basis van deze waarde.",
    "product-groups-label": "Productgroepen",
    "update-product-groups-button": "Productgroepen bijwerken"
  },
  "validation": {
    "ext": "Alleen bestanden met de extensie '{ext}' worden geaccepteerd.",
    "required": "Dit veld is verplicht",
    "totalSize": "Je kunt niet meer dan {totalSize}Mb uploaden",
    "quarterly": "De geselecteerde maanden vormen geen geldig kwartaal",
    "no-special-characters": "De invoer kan geen hashtags, aanhalingstekens, sterretjes of komma's bevatten.",
    "password": "Het wachtwoord moet minimaal {length} tekens bevatten",
    "password-repeat": "De wachtwoorden komen niet overeen",
    "email": "Voer een geldig e-mailadres in",
    "max": "Dit veld mag maximaal {max} tekens lang zijn.",
    "afterTime": "De eindtijd moet later zijn dan de begintijd",
    "min": "Dit veld moet minimaal {min} tekens lang zijn."
  },
  "dock-management": {
    "dock-scheduler-title": "Dockplanner",
    "select-location": "Locatie",
    "select-day": "Dag",
    "dock-scheduler-no-data": "Selecteer een locatie en een dag om een ​​tijdslot te bekijken en te reserveren",
    "dock-schedule-table-cell-your-booking": "Uw boeking",
    "dock-schedule-table-cell-booked-by-other": "Geboekt",
    "dock-schedule-table-cell-closed": "Gesloten",
    "error-fetching-locations": "Kan locaties niet ophalen",
    "error-fetching-dock-schedule": "Kan het schema niet ophalen",
    "docking-dialog": {
      "booking-id": "@:brand.name boekingsreferentie",
      "license-plate": "Kentekenplaat",
      "nationality": "Nationaliteit",
      "remarks": "Opmerkingen",
      "create-button": "Boek",
      "title": "Docking voor {dock} op {location}",
      "nationality-placeholder": "Kies een nationaliteit",
      "remarks-placeholder": "Bijvoorbeeld laadinstructies of opmerkingen",
      "supplier-placeholder": "Lamb Weston bijvoorbeeld",
      "license-plate-placeholder": "Bijvoorbeeld 22-BDS-02",
      "confirm-dialog": {
        "message": "Weet u zeker dat u deze boeking wilt verwijderen? \nDit wordt voor iedereen verwijderd."
      },
      "transporter": "Transporteur",
      "booking-id-tooltip": "Inkomend/uitgaand of inkoopordernummer.",
      "error-remove-booking-validation": "Annulering binnen de geplande tijd is niet toegestaan. \nNeem dan contact op met uw contactpersoon binnen @:brand.name",
      "partner-placeholder": "Kies een partner",
      "partner": "Namens"
    },
    "error-fetching-bookings": "Kan boekingen niet ophalen",
    "success-creating-booking": "Tijdslot succesvol geboekt",
    "error-creating-booking": "Mislukt bij het boeken van een tijdslot",
    "success-deleting-booking": "Boeking succesvol verwijderd",
    "error-deleting-booking": "Kan een boeking niet verwijderen",
    "success-updating-booking": "Boeking succesvol bijgewerkt",
    "error-updating-booking": "Kan een boeking niet bijwerken",
    "dock-schedule-table-cell-no-longer-available": "Dit tijdslot is niet meer beschikbaar omdat het buiten het toegestane boekingsvenster valt.",
    "dock-schedule-table-cell-loading-reference-not-found": "Referentienummer kon niet worden gevonden",
    "dock-scheduler-closed-day": "De locatie is de gehele dag gesloten.",
    "dock-schedule-table-lock-dock-tooltip": "U kunt dit dok niet sluiten, omdat er deze dag al boekingen zijn gemaakt",
    "error-unlocking-dock": "Kan het dock niet ontgrendelen",
    "error-locking-timeslot": "Kan het dock niet vergrendelen",
    "select-booking-period": "Boekingsperiode",
    "error-fetching-notifications": "Kan meldingen niet ophalen",
    "location-notifications": {
      "confirm-dialog": {
        "message": "Weet u zeker dat u deze melding wilt verwijderen?"
      },
      "add-notification": "Melding maken"
    },
    "notification-dialog": {
      "title": "Kennisgeving",
      "message": "Bericht",
      "is-active": "Is actief"
    },
    "success-deleting-notification": "Melding succesvol verwijderd",
    "error-deleting-notification": "Kan de melding niet verwijderen",
    "success-creating-notification": "Er is een melding aangemaakt",
    "error-creating-notification": "Kan geen melding maken",
    "success-updating-notification": "Melding succesvol bijgewerkt",
    "location-settings-dialog": {
      "title": "Locatie-instellingen",
      "cutoff-time": "Sluttijdstip"
    },
    "success-updating-cutoff-time": "Sluttijdstip succesvol bijgewerkt",
    "error-updating-cutoff-time": "Het bijwerken van het sluttijdstip is mislukt",
    "cutoff-time-label": "Boekingen voor de volgende dag sluiten om {time}",
    "error-updating-notification": "Kan de melding niet updaten",
    "error-fetching-partners": "Kan partners niet ophalen",
    "booking-overview-title": "Boekingsoverzicht",
    "select-docks": "Dokken",
    "export-bookings-button": "Downloaden",
    "export-bookings-subtitle": "XLSX-bestand",
    "export-bookings-title": "Download uw eerdere boekingen",
    "export-bookings-error": "Exporteren is mislukt",
    "booking-overview-table": {
      "date": "Datum",
      "time": "Tijd",
      "location": "Locatie",
      "dock": "Dok",
      "reference-number": "Boekingsreferentie",
      "partner-id": "Externe partner"
    },
    "dock-booking-overview-no-data": "Geen gegevens",
    "dock-scheduling-rules-title": "Dockplanningsregels",
    "add-dock-scheduling-rule": "Nieuwe dockplanningsregel",
    "schedule-overview-table": {
      "collapseTrigger": "{name} ({count} regels)",
      "no-data": "Er zijn nog geen regels gemaakt."
    },
    "schedule-dialog": {
      "step-1-instructions": "Kies een locatie, dock en productgroep om een ​​nieuwe regel aan te maken",
      "title": "Dockplanningsregels",
      "step-2-location": "Locatie",
      "step-2-selected-docks": "Dokken",
      "step-2-selected-product-groups": "Productgroepen",
      "location": "Locatie",
      "docks": "Dokken",
      "product-groups": "Productgroepen"
    },
    "error-fetching-product-groups": "Kan productgroepen niet ontvangen",
    "error-updating-rule": "Kan de regel niet updaten",
    "success-updating-rule": "Regel bijgewerkt",
    "error-creating-rule": "Kan geen regel maken",
    "success-creating-rule": "Regel is aangemaakt",
    "error-deleting-rule": "Kan de regel niet verwijderen",
    "success-deleting-rule": "Regel verwijderd",
    "error-fetching-rules": "Kan de regels niet ontvangen",
    "error-fetching-rule": "Kan de regels niet ontvangen"
  },
  "days": {
    "monday": "Maandag",
    "tuesday": "Dinsdag",
    "wednesday": "Woensdag",
    "thursday": "Donderdag",
    "friday": "Vrijdag",
    "saturday": "Zaterdag",
    "sunday": "Zondag"
  },
  "userMgtStore": {
    "userVendorUpdated": "De partner is bijgewerkt",
    "userProductGroupUpdated": "De productgroepen zijn bijgewerkt"
  },
  "captcha": {
    "error": "Er is iets misgegaan bij de beveiligingscontrole. Vernieuw de pagina en probeer het opnieuw.",
    "title": "Beveiligingsverificatie",
    "subtitle": "Vul de onderstaande controle in om door te gaan"
  }
}
